import { ACCOUNT_TYPE } from "../utils/constants";

export const sidebarLinks = [
  {
    id: 1,
    name: "My Profile",
    path: "/dashboard/my-profile",
    icon: "User",
  },
  {
    id: 2,
    name: "Dashboard",
    path: "/dashboard/admin",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "LayoutDashboard",
  },
  {
    id: 3,
    name: "Users",
    path: "/dashboard/my-team",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "Users",
  },
  {
    id: 4,
    name: "Start Hazop",
    path: "/dashboard/create-team",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "PlusCircle",
  },
  {
    id: 6,
    name: "Dashboard",
    path: "/dashboard/employee",
    type: ACCOUNT_TYPE.EMPLOYEE,
    icon: "LayoutDashboard",
  },
  {
    id: 7,
    name: "Buy Plan",
    path: "/features",
    type: ACCOUNT_TYPE.USER,
    icon: "ShoppingCart",
  },
  {
    id: 10,
    name: "Task Assigned",
    path: "/dashboard/task-assigned",
    type: ACCOUNT_TYPE.EMPLOYEE,
    icon: "ClipboardList",
  },
  {
    id: 11,
    name: "View Drawing Sheet",
    path: "/dashboard/view-drawingsheet",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "FileText",
  },
  {
    id: 12,
    name: "Dashboard",
    path: "/dashboard/superadmin",
    type: ACCOUNT_TYPE.SUPERADMIN,
    icon: "LayoutDashboard",
  },
  {
    id: 13,
    name: "Plants",
    path: "/plants",
    type: ACCOUNT_TYPE.SUPERADMIN,
    icon: "Factory",
  },
  {
    id: 22,
    name: "Info",
    path: "/dashboard/info",
    icon: "Info",
  },
];